module.exports = __webpack_public_path__ + "static/img/logo-kiamotors.437f60b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/logo-kiamotors.png
// module id = mi9Q
// module chunks = 0